// extracted by mini-css-extract-plugin
export default {"assessmentresponsemain":"AssessmentResponse_assessmentresponsemain__hTlFN","assessmentresponsecontentwrapper":"AssessmentResponse_assessmentresponsecontentwrapper__waX2d"};